module.exports = __webpack_public_path__ + "static/media/fretador-fundo-small.39a22844.png";